import React, { useEffect, useState } from 'react';

import { styled } from '@mui/material/styles';

import ErrorComponent from '@fd/ui/ErrorComponent';

import { isTrustedPortalRedirectUrl } from '../../helpers/portalHost';
import Loading from '../Loading';

const StyledEmptyComponentContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
});

const UberEatsOAuthCallbackPage = () => {
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const callbackUrl = params.get('callbackUrl');

    if (callbackUrl) {
      // To run this on LOCAL environment comment out below if statement
      if (!isTrustedPortalRedirectUrl(callbackUrl)) {
        setShowError(true);
        return;
      }

      params.delete('callbackUrl');

      const callbackUrlObj = new URL(callbackUrl, window.location.origin);
      params.forEach((value, key) => callbackUrlObj.searchParams.set(key, value));

      window.location.replace(callbackUrlObj.toString());
    } else {
      setShowError(true);
    }
  }, []);

  return showError ? (
    <StyledEmptyComponentContainer>
      <ErrorComponent title="Something_went_wrong" />
    </StyledEmptyComponentContainer>
  ) : (
    <Loading fullscreen animate />
  );
};

export default UberEatsOAuthCallbackPage;
